/**
 * This controller handel the data for the consumer info widget and arrange the data in the model for the public model and SDK
 * @type {*|{}}
 */
define(function (require) {

    window.lpTag = window.lpTag || {};

    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpBaseInfoController = require('web-agent-assets-js/lpBaseInfoController');
    var lpGoalsController = require('web-agent-assets-js/lpGoalsController');
    var lpWindowController = require('web-agent-assets-js/lpWindowController');
    var lpEngagementsController = require('web-agent-assets-js/lpEngagementsController');
    var lpLobsController = require('web-agent-assets-js/lpLobsController');
    var lpCampaignsController = require('web-agent-assets-js/lpCampaignsController');
    var lpVisitorProfileController = require('web-agent-assets-js/lpVisitorProfileController');
    var lpVisitorBehaviorController = require('web-agent-assets-js/lpVisitorBehaviorController');
    var lpAgentSessionVisitController = require('web-agent-assets-js/lpAgentSessionVisitController');
    var lpAppInstallController = require('web-agent-assets-js/lpAppInstallController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var lpAppInstall = require('web-agent-assets-js/lpAppInstall');
    var lpMessagingEngagementsHistoryService = require('web-agent-services/lpMessagingEngagementsHistoryService');
    var lpMessagingEngagementHistoryTableAdapter = require('web-agent-adapters/lpMessagingEngagementHistoryTableAdapter');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');
    var CONSUMER_INFO_REQUEST_TIMEOUT = 15000;

    var lpConsumerInfoController = function (model, config) {
        this.applicationType = "lpConsumerInfoController";
        var messagingEngagementHistoryTableAdapter = new lpMessagingEngagementHistoryTableAdapter({
            model: model,
            service: new lpMessagingEngagementsHistoryService()
        });

        var logger = WebAgentLogger.getLogger(this.applicationType);
        var userProfilesPath = 'userProfiles.';
        var chatPath = 'chats.';
        // Use this object to store data for the binding event.
        var visitorsData = {};

        this.getConsumerInfoData = function (data) {
            getConsumerInfoData(data);
        };

        this.handleVisitorDisposed = function (visitorId) {
            handleVisitorDisposed(visitorId);
        };

        /**
         * Bind to userProfiles in the model
         * @param visitorId
         */
        function bindUserProfile(visitorId) {
            unbindUserProfile(visitorId);
            model.bind(userProfilesPath + visitorId, userProfileUpdated, this);
        }

        /**
         * Unbind to userProfiles in the model
         * @param visitorId
         */
        function unbindUserProfile(visitorId) {
            model.unbind(userProfilesPath + visitorId, userProfileUpdated, this);
        }

        /**
         * when userProfiles in the model updated, we need to organize the user data in the model. and unbind the model
         * @param data
         */
        function userProfileUpdated(data) {
            if (data) {
                var visitorId = data.key.split(".")[1];
                // This is a bind-ones logic, so we need to unbind. and call the combineConsumerInfoData to get the user profile data and combine it
                if (visitorId) {
                    unbindUserProfile(visitorId);
                    combineConsumerInfoData(visitorsData[visitorId]);
                }
            }
        }

        function chatInfoUpdated(data) {
            if (data) {
                var chatId = data.key.split(".")[1];
                var visitorId = model.get(chatPath + chatId + ".visitorInfo.visitorId");
                if (visitorId) {
                    combineConsumerInfoData(visitorsData[visitorId]);
                }
            }
        }

        /**
         * uses convId, campaignId, engagementId to get data from APIs or from the infoServices in the model
         * @param {Object} context
         * @param {Number} campaignId
         * @param {Number} engagementId
         */
        function getCampaignInfo(context, campaignId, engagementId) {
            if (!_.isNumber(campaignId) || !_.isNumber(engagementId)) {
                return;
            }

            var apiGetters = initializeApisGetters();
            var serviceNames = lpConsumerInfoController.prototype.serviceNames;

            var goalsController = new lpGoalsController(model);
            var windowController = new lpWindowController(model);
            var engagementsController = new lpEngagementsController(model, {
                getWindow: windowController.getWindow,
                windowContext: windowController
            });
            var lobsController = new lpLobsController(model);
            var campaignsController = new lpCampaignsController(model, {
                getLob: lobsController.getLob,
                lobContext: lobsController
            });
            var visitorProfileController = new lpVisitorProfileController(model);
            var visitorBehaviorController = new lpVisitorBehaviorController(model);
            var appInstallController = new lpAppInstallController(model);

            function modifyCurrentPollingData(model, path, value, arrayUniqueId) {
                var endPath = path || '';
                var currentPollingData = model.get(lpBaseInfoController.prototype.CURRENT_POLLING_MODEL_LOCATION);
                var valueHasId = value && (value.id || (value[0] && value[0].id));

                if (model && valueHasId && currentPollingData && currentPollingData.returnedServices && currentPollingData.requestedServices && currentPollingData.data) {
                    model.modify(lpConsumerInfoController.prototype.CURRENT_POLLING_MODEL_LOCATION + endPath, value, arrayUniqueId);
                }
            }
            /**
             * handles requests successes and errors
             */
            var handler = {
                /**
                 * if the API returns an success-
                 * 1. calls handleACRequestSuccess from BaseInfoConteroller (which updates the returned service with the status 'success', sets the data in the infoServices and in the 'current' participant).
                 * 2. gets further information if needed. such as goal, lob...
                 */
                handleSuccess: {
                    campaigns: function (res) {
                        if (res && res.body && res.body.visitorProfiles) {
                            res.body._visitorProfileId = res.body.visitorProfiles[0];
                        }

                        var campaignData = res.body;

                        getInfoItem.goal(campaignData.goalId);
                        getInfoItem.visitorProfiles(campaignData.visitorProfiles);
                        getInfoItem.lob(campaignData.lobId);
                        lpConsumerInfoController.prototype.handleACRequestSuccess(model, res, serviceNames.campaigns, campaignsController.getSingleCampaignObject, getContextObject(res));
                    },
                    engagements: function (res) {
                        if (res && res.body) {
                            if (res.body.visitorBehaviors) {
                                res.body._visitorBehaviorId = res.body.visitorBehaviors[0];
                            }
                            if (res.body.appInstallationId) {
                                res.body.source = {
                                    id: res.body.appInstallationId,
                                    appInstallationId: res.body.appInstallationId
                                };
                                getInfoItem.appInstall(res.body.appInstallationId);
                            }
                            getInfoItem.visitorBehaviors(res.body.visitorBehaviors);
                            lpConsumerInfoController.prototype.handleACRequestSuccess(model, res, serviceNames.engagements, engagementsController.getSingleEngagementsObject, getContextObject(res));
                        }
                    },
                    goals: function (res) {
                        lpConsumerInfoController.prototype.handleACRequestSuccess(model, res, serviceNames.goals, goalsController.getSingleGoalObject, getContextObject(res));
                    },
                    lob: function (res) {
                        lpConsumerInfoController.prototype.handleACRequestSuccess(model, res, serviceNames.lob, lobsController.getSingleLobObject, getContextObject(res));
                    },
                    visitorProfile: function (res) {
                        if (res && res.body && res.body.isSystemDefault) {
                            res.body.name = agentLEManager.translateLE("LEWebAgent.visitorProfile.default.name");
                            res.body.description = agentLEManager.translateLE("LEWebAgent.visitorProfile.default.description");
                        }
                        lpConsumerInfoController.prototype.handleACRequestSuccess(model, res, serviceNames.visitorProfile, visitorProfileController.getSingleVisitorProfileObject, getContextObject(res));
                    },
                    visitorBehavior: function (res) {
                        if (res && res.body && res.body.isSystemDefault) {
                            res.body.name = agentLEManager.translateLE("LEWebAgent.visitorBehavior.default.name");
                            res.body.description = agentLEManager.translateLE("LEWebAgent.visitorBehavior.default.description");
                        }
                        lpConsumerInfoController.prototype.handleACRequestSuccess(model, res, serviceNames.visitorBehavior, visitorBehaviorController.getSingleVisitorBehaviorObject, getContextObject(res));
                    },
                    appInstall: function (res) {
                        lpConsumerInfoController.prototype.handleACRequestSuccess(model, res, serviceNames.appInstall, appInstallController.getSingleAppInstallObject, getContextObject(res));
                    }
                },
                /**
                 * if the API returns an error-
                 * it calls handleRequestError from BaseInfoConteroller (which updates the returned service with the status 'error').
                 */
                handleError: {
                    _handleRequestError: function (res, requestName) {
                        logger.error("Error getting campaignInfo: " + requestName, "getCampaignInfo", res);
                        lpConsumerInfoController.prototype.handleRequestError(model, res.body, serviceNames[requestName], context.visitorId);
                    },
                    campaigns: function (res) {
                        handler.handleError._handleRequestError(res, 'campaigns');
                    },
                    engagements: function (res) {
                        handler.handleError._handleRequestError(res, 'engagements');
                    },
                    goals: function (res) {
                        handler.handleError._handleRequestError(res, 'goals');
                    },
                    lob: function (res) {
                        handler.handleError._handleRequestError(res, 'lob');
                    },
                    visitorProfile: function (res) {
                        handler.handleError._handleRequestError(res, 'visitorProfile');
                    },
                    visitorBehavior: function (res) {
                        handler.handleError._handleRequestError(res, 'visitorBehavior');
                    },
                    appInstall: function (res) {
                        handler.handleError._handleRequestError(res, 'appInstall');
                    }
                }
            };

            /**
             * gets data by ID
             */
            var getInfoItem = {
                /**
                 * gets information for the requested id and serviceName
                 * if the requested data exists in the model-
                 * 1. it sets the info in the current participant .
                 *    * if 'campaign'/'engagement'- gets the additional data required
                 * otherwise-
                 * 1. it creates an Api of the requested service and an empty object to be filled when the data arrives.
                 * 2. requests the data
                 * @param {String} serviceName - the service name as appears in BaseInfoConteroller.serviceNames
                 * @param {String} dataPathInParticipant - the path in participants.info to be updated
                 * @param {Array} ids
                 */
                _generic: function (serviceName, dataPathInParticipant, ids, isArray) {
                    if (!serviceName || !dataPathInParticipant || _.include(ids, undefined)) {
                        return;
                    }
                    var dataFromService = model.get(serviceNames[serviceName] + '.data.' + ids[0]);
                    if (dataFromService) {
                        if (dataPathInParticipant === 'campaign') {
                            getInfoItem.goal(dataFromService.goalId);
                            getInfoItem.visitorProfiles(dataFromService._visitorProfileId);
                            getInfoItem.lob(dataFromService.lobId);
                        }
                        else if (dataPathInParticipant === 'engagement') {
                            getInfoItem.visitorBehaviors(dataFromService._visitorBehaviorId);
                            if (dataFromService.source && dataFromService.source.appInstallationId) {
                                getInfoItem.appInstall(dataFromService.source.appInstallationId);
                            }
                        }
                        modifyCurrentPollingData(model, '.data.' + dataPathInParticipant, isArray ? [dataFromService] : dataFromService);
                        return;
                    }
                    else {
                        var emptyDataObj = isArray ? [{ id: ids[0] }] : { id: ids[0] };
                        modifyCurrentPollingData(model, '.data.' + dataPathInParticipant, emptyDataObj);
                    }

                    // if the info is missing- use the api to get it
                    lpConsumerInfoController.prototype.addServiceToRequestedServices(serviceNames[serviceName], { data: { visitorId: context.visitorId } }, model);

                    var result = [{ success: handler.handleSuccess[serviceName], error: handler.handleError[serviceName] }];
                    apiGetters[serviceName].apply(null, result.concat(ids));
                },
                campaign: function (campaignId) {
                    getInfoItem._generic('campaigns', 'campaign', [campaignId]);
                },
                engagement: function (campaignId, engagementId) {
                    getInfoItem._generic('engagements', 'engagement', [engagementId, campaignId]);
                },
                goal: function (goalId) {
                    getInfoItem._generic('goals', 'goal', [goalId]);
                },
                lob: function (lobId) {
                    getInfoItem._generic('lob', 'lob', [lobId]);
                },
                visitorProfiles: function (visitorProfileId) {
                    getInfoItem._generic('visitorProfile', 'visitorProfile', [visitorProfileId], true);
                },
                visitorBehaviors: function (visitorBehaviorId) {
                    getInfoItem._generic('visitorBehavior', 'visitorBehavior', [visitorBehaviorId], true);
                },
                appInstall: function (appInstallationId) {
                    getInfoItem._generic('appInstall', 'engagement.source', [appInstallationId]);
                }
            };


            if (campaignId && engagementId) {
                getInfoItem.campaign(campaignId);
                getInfoItem.engagement(campaignId, engagementId);
            }

            function getContextObject(res) {
                return {
                    dataObject: { visitorId: context.visitorId },
                    id: res.body.id,
                    visitorId: context.visitorId,
                    responseCode: res.responseCode
                };
            }

            function initializeApisGetters() {
                return {
                    campaigns: new lpTag.Campaigns().getCampaign,
                    engagements: new lpTag.Engagements().getEngagement,
                    goals: new lpTag.Goals().getGoal,
                    lob: new lpTag.Lobs().getLob,
                    visitorProfile: new lpTag.VisitorProfiles().getProfile,
                    visitorBehavior: new lpTag.VisitorBehaviors().getBehavior,
                    appInstall: new lpAppInstall().getAppInstall
                };
            }
        }



        function getConversationIdFromCurrentPollingData() {
            return model.get(lpConsumerInfoController.prototype.CURRENT_POLLING_MODEL_LOCATION + '.data.conversationId');
        }

    function getSdesInfo(context) {
        lpConsumerInfoController.prototype.addServiceToRequestedServices(lpConsumerInfoController.prototype.serviceNames.engagementHistory, { data: { visitorId: context.visitorId } }, model);
        var conversationStart = model.get(lpTag.WebAgent.logicController.getParticipantPath(context.visitorId) + '.participantInfo.chatStartTime');
        var conversationId = context.convId;

        var reqObj = {
            searchType: lpMessagingEngagementHistoryTableAdapter.SEARCH_TYPES.ByConversation,
            data: {
                conversationId: conversationId,
                start: { from: conversationStart, to: -1 },
                contentToRetrieve: lpMessagingEngagementHistoryTableAdapter.CONTENT_BLOCKS.MONITORING,
                cappingConfiguration: lpMessagingEngagementHistoryTableAdapter.CAPPING_CONFIGURATION.SINGLE,
            },
            error: handleGetSdesError,
            success: handleGetSdesSuccess
        };

        if (lpTag.WebAgent.logicController.isAgentOnly() && privilegesController.hasViewAllChatsPrivilege() && !lpTag.WebAgent.logicController.isMyChat(conversationId)) {
            var assignedAgent = model.get('chats.' + context.convId + '.agentInfo.agentId');
            if (assignedAgent) {
                reqObj.data.latestAgentId = assignedAgent;
            }
        }

        messagingEngagementHistoryTableAdapter.searchEngagements(reqObj);

            // when the response is taking too long- call error so rendering will occur
            var errorTimeout = setTimeout(handleGetSdesError.bind(null, 'timeout'), CONSUMER_INFO_REQUEST_TIMEOUT);

            function handleGetSdesSuccess(res) {
                if (!conversationId || conversationId !== getConversationIdFromCurrentPollingData()) {
                    // ignore the request if the context is wrong
                    return;
                }

                logger.info("", "getSdesInfo", res);
                clearTimeout(errorTimeout);
                var visitorSdes = {};
                var chatData = res && res.data && res.data[0] && res.data[0].chatData;
                var visitorInfo = chatData && chatData.visitorInfo;
                if (visitorInfo) {
                    for (var sde in visitorInfo) {
                        switch (sde) {
                            // sdes
                            case 'customer':
                            case 'personal':
                            case 'personalInfo':
                            case 'marketing':
                            case 'lead':
                            case 'purchase':
                            case 'viewed':
                            case 'vehicleOfInterest':
                            case 'cart':
                            case 'service':
                            case 'visitorError':
                            case 'searchContent':
                            //monitoring data
                            case 'country':
                            case 'countryCode':
                            case 'geoState':
                            case 'geoCity':
                            case 'isp':
                            case 'deviceFamily':
                            case 'browser':
                            case 'organization':
                            case 'ipv4':
                            case 'externalReferrer':
                            case 'externalReferrerTitle':
                            case 'sharkVisitorId':
                                visitorSdes[sde] = visitorInfo[sde];
                                break;
                            default:
                                break;
                        }
                    }
                }
                lpConsumerInfoController.prototype.addDataObjectToVisitorInfo(model, visitorSdes, lpConsumerInfoController.prototype.serviceNames.engagementHistory);
            }

            function handleGetSdesError(res) {
                logger.error("Error getting sdesInfo: ", "getSdesInfo", res);
                lpConsumerInfoController.prototype.handleRequestError(model, res.body, lpConsumerInfoController.prototype.serviceNames.engagementHistory, context.visitorId);
                clearTimeout(errorTimeout);
            }
        }


        function getConsumerInfoData(data) {
            logger.info("", "getConsumerInfoData", data);
            if (data) {
                var visitorId = data.visitorId;
                if (visitorId) {
                    if (!visitorsData[visitorId] || getChatIdByVisitor(visitorId) !== getChatIdFromData(data)) {
                        handleNewChat(data);
                    }
                    bindUserProfile(visitorId);
                    // call the UserProfilesController to get the user profile data
                    lpTag.WebAgent.amsUserProfilesController.getUserProfile({
                        consumerId: visitorId
                    }, true);

                    var campaignDetails = resolveCampaignDetails(data.convId);
                    if (campaignDetails.campaignId && campaignDetails.engagementId) {
                        getCampaignInfo(data, campaignDetails.campaignId, campaignDetails.engagementId);
                    }

                    if (lpTag.WebAgent.logicController.getMessagingSdesSiteSetting()) {
                        getSdesInfo(data);
                    }
                }
            }

            function resolveCampaignDetails(conversationId) {
                var chatInfo = model.get('chats.' + conversationId + '.chatInfo');
                var connectionListInfo = model.get('connectionsList.data.' + conversationId + '.conversationDetails.campaignInfo');
                var campaignInfo = {};
                if (chatInfo && chatInfo.campaignId && chatInfo.engagementId) {
                    campaignInfo.campaignId = chatInfo.campaignId;
                    campaignInfo.engagementId = chatInfo.engagementId;
                }
                else if (connectionListInfo && connectionListInfo.campaignId && connectionListInfo.engagementId) {
                    campaignInfo.campaignId = connectionListInfo.campaignId;
                    campaignInfo.engagementId = connectionListInfo.engagementId;
                }
                return campaignInfo;
            }
        }

        /**
         * This function combine the user profile data & chat with consumer data and set it in the model
         * @param data
         */
        function combineConsumerInfoData(data) {
            var visitorId, chatId;
            if (data) {
                visitorId = data.visitorId;
                chatId = getChatIdFromData(data);
            }
            if (getVisitorIdFromCurrentPollingData() !== visitorId) {
                return;
            }
            if (visitorId && chatId) {
                var visitorData;
                visitorData = model.get(userProfilesPath + visitorId);
                var processedItem = {};
                var chatData = model.get(chatPath + chatId);
                var accountId = model.get("account");
                if (chatData) {
                    var chatInfo = chatData.chatInfo;
                    if (chatInfo) {
                        if (chatInfo.CSATRate) {
                            processedItem.CSATRate = chatInfo.CSATRate;
                        }

                        var skill = lpTag.WebAgent.logicController.getSkillName(chatInfo.skillIds);
                        if (skill) {
                            processedItem.skill = skill;
                        }

                        if (chatData.agentInfo){
                            processedItem.agentName = chatData.agentInfo.agentName;
                            processedItem.agentNickName = chatData.agentInfo.agentName;
                            processedItem.agentId = chatData.agentInfo.agentId;
                            processedItem.employeeId = model.get("agent.employeeId");
                            if (agentLEManager.hasAgentGroupsFeature()) {
                                processedItem.agentGroupName = lpTag.WebAgent.logicController.getAgentGroupNameById(parseInt(chatData.agentInfo.agentId, 10));
                            }
                        }

                        if (chatData.visitorInfo) {
                            processedItem.spectatedEngagement = chatData.visitorInfo.spectatedEngagement;
                            processedItem.acceptedEngagement = chatData.visitorInfo.acceptedEngagement;
                        }

                        processedItem.rtSessionId = chatInfo.chatId;
                        processedItem.conversationId = chatInfo.chatId;
                        processedItem.isConversationResolved = chatInfo.isConversationResolved;

                        processedItem.startTime = chatInfo.startTime;
                        processedItem.chatAcceptTime = chatInfo.startTime;
                        processedItem.chatRequestTime = chatData.visitorInfo.engagementStartTime;

                        processedItem.operatingSystem = chatInfo.os;
                        processedItem.deviceFamily = chatInfo.deviceFamily;
                        if (chatInfo.browser && chatInfo.browser != "UNKNOWN") {
                            processedItem.browser = chatInfo.browser;

                            if (chatInfo.browserVersion) {
                                processedItem.browser += " " + chatInfo.browserVersion;
                            }
                        }
                        processedItem.channelSource = chatInfo.channelSource;
                        processedItem.engagementType = chatInfo.engagementType;

                        processedItem.dialogs = getDialogs(chatInfo.dialogs);

                        // We can't update the state using the addDataObjectToVisitorInfo, it will delete all the chat lines so, we set it manuel.
                        // Todo: we need to fix the addDataObjectToVisitorInfo to support that.
                        model.modify("participants.info." + visitorId + ".data.currentChatState", chatInfo.state);

                    }

                }
                if (accountId) {
                    processedItem.accountId = accountId;
                }
                if (visitorData) {
                    processedItem.isMessaging = true;
                    processedItem.visitorName = visitorData.fullName;
                    processedItem.visitorId = visitorData.userId;
                    processedItem.description = visitorData.description;
                    if (visitorData.participant) {
                        processedItem.participant = visitorData.participant;
                    }
                    if (visitorData.claimsAndAuthType) {
                        processedItem.claimsAndAuthType = visitorData.claimsAndAuthType;
                    }
                    if (visitorData.cSat) {
                        processedItem.CSATPercentText = visitorData.cSat.percentText;
                    }

                    var preChatNamedQuestions = {
                        phoneNumber: {
                            value: visitorData.description,
                            displayName: visitorData.description
                        },
                        identifier: {
                            value: visitorData.fullName,
                            displayName: visitorData.fullName
                        }
                    };

                    processedItem.preChatNamedQuestions = preChatNamedQuestions;
                }

                lpAgentSessionVisitController.prototype.addDataObjectToVisitorInfo(model, processedItem, lpAgentSessionVisitController.prototype.serviceNames.consumerInfo);
            }

            function getVisitorIdFromCurrentPollingData() {
                return model.get(lpConsumerInfoController.prototype.CURRENT_POLLING_MODEL_LOCATION + '.data.visitorId');
            }
        }

        function getDialogs(dialogs) {
            var newDialogs = {};
            _.each(dialogs, function (dialog) {
                newDialogs[dialog.dialogId] = {
                    dialogType: dialog.dialogType,
                    channelType: dialog.channelType,
                    state: dialog.state,
                    creationTs: dialog.creationTs,
                    participantsDetails: getParticipantsDetails(dialog.participantsDetails),
                    suggestedParticipantsDetails: getParticipantsDetails(dialog.suggestedParticipantsDetails)
                };
            });
            return newDialogs;

            function getParticipantsDetails(participantsDetails) {
                var participants = {};
                _.each(participantsDetails, function (participant, participantId) {
                    participants[participantId] = {
                        id: participant.id,
                        fullName: participant.fullName,
                        role: participant.role,
                        state: participant.state
                    };
                });
                return participants;
            }
        }

        /**
         * For the firstTime we get request to handle a new chat, we add bind to the chatTranscript so we can update the lines in the model immediately
         * @param data
         */
        function handleNewChat(data) {
            var visitorId = data.visitorId;
            unbindChat(visitorId);
            // store the data to use it on the bind trigger events.
            visitorsData[visitorId] = data;
            var chatId = getChatIdFromData(data);
            model.bind(chatPath + chatId + ".oldChatLine", handelNewChatLines, this);
            model.bind(chatPath + chatId + ".newChatLine", handelNewChatLines, this);
        }

        function handelNewChatLines(data) {
            var chatId = data.key.split(".")[1];
            if (data && data.newValue && data.newValue.lines) {
                var cleanLines = prepareChatLines(data.newValue.lines);
                if (cleanLines && cleanLines.length > 0) {
                    var visitorId = model.get(chatPath + chatId + ".visitorInfo.visitorId");
                    model.modify("participants.info." + visitorId + ".data.currentChat.lines", cleanLines, "id");
                }
            }
        }

        /**
         * This function go over the chatLines, clear the duplicate liens, sort them and create object for each one.
         * @param chatLines
         * @returns {Array}
         */
        function prepareChatLines(chatLines){
            if (!chatLines || chatLines.length === 0) {
                return;
            }
            // The list can be not sorted with duplicate lines.
            // so we build an object to temporary store the lines with no duplication and then use Object.keys to sort it to array.
            var linesObject = {};
            for (var i = 0, maxLine = chatLines.length; i < maxLine; i++) {
                if (typeof chatLines[i].id !== 'undefined') {
                    linesObject[chatLines[i].id] = {
                        by: chatLines[i].by,
                        id: chatLines[i].id,
                        source: chatLines[i].source,
                        subType: chatLines[i].subType,
                        systemMessageId: chatLines[i].systemMessageId,
                        text: chatLines[i].text,
                        textType: chatLines[i].textType,
                        time: chatLines[i].time,
                        type: chatLines[i].type,
                        status: chatLines[i].status,
                        dialogId: chatLines[i].dialogId,
                        clientProperties: chatLines[i].originatorClientProperties};
                }
            }
            var cleanLines = Object.keys(linesObject).map(function(val) { return linesObject[val]; });
            return cleanLines;
        }

        /**
         * Unbind to chatTranscript when visitor disposed
         * @param visitorId
         */
        function handleVisitorDisposed(visitorId) {
            unbindChat(visitorId);
            delete visitorsData[visitorId];
        }

        function unbindChat(visitorId) {
            var chatId = getChatIdByVisitor(visitorId);
            if (chatId) {
                model.unbind(chatPath + chatId + ".newChatLine", handelNewChatLines, this);
                model.unbind(chatPath + chatId + ".oldChatLine", handelNewChatLines, this);
            } else {
                logger.debug(visitorId, "No chat to unbind");
            }
        }

        function getChatIdFromData(data) {
            return data.chatId || data.convId;
        }

        function getChatIdByVisitor(visitorId) {
            return visitorsData[visitorId] ? getChatIdFromData(visitorsData[visitorId]) : null;
        }
    };
    lpConsumerInfoController.prototype = new lpBaseInfoController();

    return lpConsumerInfoController;

});
